<template>
  <div id="nationalDetail">
    <page-header :noBack="true">
      自媒体主页
    </page-header>
    <div class="info_wrap">
      <div class="headimgs">
        <img class="headimg" :src="infor.logoUrl" alt="">
      </div>
      <div class="num_wrap">
        <div class="nums">
          <div class="item">
            <div class="num">{{infor.number}}</div>
            <div class="title">发布</div>
          </div>
          <div class="item">
            <div class="num">{{infor.attentNum}}</div>
            <div class="title">粉丝</div>
          </div>
          <div class="item">
            <div class="num">{{infor.likeNum}}</div>
            <div class="title">获赞</div>
          </div>
        </div>
        <div class="desc">
          简介：{{infor.introduce}}
        </div>
      </div>
    </div>
    <div class="navs">
      <div class="nav" :class="{'active': navIndex === index}" v-for="(item, index) in navs" :key="index" @click="navToggle(index)">{{item}}</div>
    </div>
    <div class="article_lists" v-if="navIndex === 0">
      <div class="list" v-for="(item, index) in articles" :key="index" @click="goDetail(item)">
        <div class="infor">
          <div class="headimgs">
            <img class="headimg" :src="item.logoUrl" alt="">
          </div>
          <div class="names">
            <div class="name">{{item.name}}</div>
            <div class="time">{{item.createTime.split(' ')[0]}}</div>
          </div>
        </div>
        <div class="detail">
          <div class="title">{{item.title}}</div>
          <div class="imgs">
            <img class="img" :src="item.coverImg" alt="">
          </div>
        </div>
        <div class="num_wrap">
          <div class="nums">
            <img class="icon" src="../assets/img/icon_dianzan_1.png" alt="">
            <span class="num">{{item.likeNum}}</span>
          </div>
          <div class="nums">
            <img class="icon" src="../assets/img/icon_msg_1.png" alt="">
            <span class="num">{{item.commentNum}}</span>
          </div>
          <div class="nums">
            <img class="icon" src="../assets/img/icon_share_1.png" alt="">
            <span class="num">{{item.collectionNum}}</span>
          </div>
        </div>
      </div>
      <div class="public_no_data" v-if="articles.length === 0 && canReq && !hasMore">TA没有发布内容哦~</div>
      <div class="public_no_more" v-if="articles.length !== 0 && canReq && !hasMore">没有更多了</div>
    </div>
    <div class="video_lists" v-else>
      <div class="list" v-for="(item, index) in videos" :key="index" v-show="item.coverImg" @click="goVideoDetail(item)">
        <div class="video_wrap">
          <img class="cover_img" :src="item.coverImg" alt="">
          <div class="title">{{item.title}}</div>
          <div class="nums">{{item.readingVolume}}次播放</div>
          <div class="btns">
            <img src="../assets/img/icon_start.png" alt="">
          </div>
        </div>
        <div class="infor_wrap">
          <div class="infors">
            <div class="headimgs">
              <img class="headimg" :src="item.logoUrl" alt="">
            </div>
            <div class="name">{{item.name}}</div>
          </div>
          <div class="icons">
            <img src="../assets/img/icon_dianzan_1.png" alt="">
            <img src="../assets/img/icon_msg_1.png" alt="">
            <img src="../assets/img/icon_share_1.png" alt="">
          </div>
        </div>
      </div>
      <div class="public_no_data" v-if="videos.length === 0 && canReq && !hasMore">TA没有发布内容哦~</div>
      <div class="public_no_more" v-if="videos.length !== 0 && canReq && !hasMore">没有更多了</div>
    </div>
    <div class="download_wrap">
      <div class="left_wrap">
        <img class="logo" src="../assets/img/logo_1.png" alt="">
        <div class="name">学习国防</div>
      </div>
      <router-link to="/download" tag="div" class="btn">下载App</router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: "nationalDetail",
  data() {
    return {
      id: this.$route.query.id || '59ba1ff361d64a718d7ee30ff41cd40c',
      navs: ['文章', '视频'],
      navIndex: 0,
      infor: {},
      articles: [],
      videos: [],
      canReq: true,
      hasMore: true,
      page: 1
    };
  },
  computed: {
    withBottomScroll() {
      return this.$store.state.onscroll.withBottom;
    }
  },
  watch: {
    withBottomScroll () {
      if (this.withBottomScroll < 50 && this.canReq && this.hasMore) {
        if (this.navIndex === 0) {
          this.getArticle();
        } else {
          this.getVideo();
        }
      }
    }
  },
  mounted () {
    this.getInfo ();
    this.getArticle();
    this.getVideo();
  },
  methods: {
    navToggle (index) {
      this.navIndex = index;
      this.canReq = true;
      this.hasMore = true;
      this.page = 1;
      this.articles = [];
      this.videos = [];
      if (index === 0) {
        this.getArticle();
      } else {
        this.getVideo();
      }
    },
    getInfo () {
      this.axios.get('/xxgf-api/api/nationaldefense/getDetail?id=' + this.id)
        .then(({data}) => {
          if (data.code === 200) {
            this.infor = data.data;
          }
        });
    },
    getArticle () {
      this.canReq = false;
      this.axios.get('/xxgf-api/api/nationaldefense/getDetailDynamicList', {
        params: {
          id: this.id,
          pageNum: this.page,
          pageSize: 10
        }
      })
        .then(({data}) => {
          if (data.code === 200) {
            this.canReq = true;
            this.page++;
            this.articles = this.articles.concat(data.rows);
            if (!data.rows || !data.rows.length || data.rows.length < 10 ) {
              this.hasMore = false;
            }
          }
        })
    },
    getVideo () {
      this.canReq = false;
      this.axios.get('/xxgf-api/api/nationaldefense/getDetailVedioList', {
        params: {
          id: this.id,
          pageNum: this.page,
          pageSize: 10
        }
      })
        .then(({data}) => {
          if (data.code === 200) {
            this.canReq = true;
            this.page++;
            this.videos = this.videos.concat(data.rows);
            if (!data.rows || !data.rows.length || data.rows.length < 10 ) {
              this.hasMore = false;
            }
          }
        })
    },
    goDetail (item) {
      this.$router.push({path: '/newDetail', query: {id: item.id, type: 14}});
    },
    goVideoDetail (item) {
      this.$router.push({path: '/nationalVideoDetail', query: {id: item.id}});
    }
  }
};
</script>

<style lang="scss">

#nationalDetail {
  width: 100%;
  padding-top:94px;
  padding-bottom:120px;
  .info_wrap{
    height:240px;
    background:#fff;
    padding:30px;
    display:flex;
    justify-content: space-between;
    .headimgs{
      width:100px;
      height:100px;
      border-radius: 50%;
      overflow: hidden;
      .headimg{
        width:100%;
        height:100%;
        object-fit: cover;
      }
    }
    .num_wrap{
      width:570px;
      .nums{
        width:570px;
        display:flex;
        .item{
          flex:1;
          text-align:center;
          .num{
            font-size:36px;
            font-weight: bold;
          }
          .title{
            font-size:28px;
            color:#666;
          }
        }
      }
      .desc{
        font-size:24px;
        color:#999;
        margin-top:20px;
        word-break:break-all;
      }
    }
  }
  .navs{
    height:114px;
    width:100%;
    background:#fff;
    display:flex;
    border-bottom:1px solid #e6e6e6;
    border-top:20px solid #f5f5f5;
    .nav{
      flex:1;
      text-align:center;
      line-height:94px;
      font-size:30px;
      &.active{
        color:#D72F1D;
      }
    }
  }
  .article_lists{
    .list{
      background:#fff;
      padding: 30px 30px 0;
      margin-bottom:20px;
      .infor{
        display:flex;
        align-items: center;
        .headimgs{
          width:66px;
          height:66px;
          border-radius: 50%;
          margin-right:20px;
          .headimg{
            width:100%;
            height:100%;
            object-fit: cover;
          }
        }
        .names{
          line-height:40px;
          .name{
            font-size:26px;
          }
          .time{
            font-size:22px;
            color:#999;
          }
        }
      }
      .detail{
        padding-bottom:20px;
        .title{
          font-size:32px;
          line-height:50px;
          padding:10px 0;
        }
        .imgs{
          width:100%;
          height:390px;
          overflow: hidden;
          .img{
            width:100%;
            height:100%;
            object-fit: cover;
          }
        }
      }
      .num_wrap{
        height:80px;
        display:flex;
        border-top:1px solid #e6e6e6;
        .nums{
          flex:1;
          display:flex;
          align-items: center;
          justify-content: center;
          .icon{
            width:30px;
            height:30px;
            margin-right:10px;
          }
          .num{
            font-size:22px;
            color:#777777;
          }
        }
      }
    }
  }
  .video_lists{
    .list{
      margin-bottom:20px;
      background:#fff;
      .video_wrap{
        width:100%;
        height:420px;
        position:relative;
        color:#fff;
        .cover_img{
          width:100%;
          height:100%;
          object-fit: cover;
        }
        .title{
          width:100%;
          height:80px;
          line-height:80px;
          padding:0 30px;
          position:absolute;
          left:0;
          top:0;
          z-index:1;
          background:linear-gradient(180deg, rgba($color: #000000, $alpha: 0.5), rgba($color: #000000, $alpha: 0))
        }
        .nums{
          position:absolute;
          left:0;
          bottom:0;
          z-index:2;
          line-height:80px;
          padding:0 30px;
          font-size:24px;
        }
        .btns{
          width:80px;
          height:80px;
          border-radius: 50%;
          background:rgba($color: #000000, $alpha: 0.5);
          padding: 20px;
          position:absolute;
          top:50%;
          left:50%;
          z-index:3;
          transform: translate(-50%, -50%);
          img{
            width:40px;
            height:40px;
            display:block;
          }
        }
      }
      .infor_wrap{
        height:120px;
        display:flex;
        align-items: center;
        justify-content: space-between;
        padding:0 30px;
        .infors{
          display:flex;
          align-items: center;
          .headimgs{
            width:66px;
            height:66px;
            border-radius: 50%;
            overflow: hidden;
            margin-right:20px;
            .headimg{
              width:100%;
              height:100%;
              object-fit: cover;
            }
          }
        }
        .icons{
          img{
            width:30px;
            height:30px;
            margin-left:20px;
          }
        }
      }
    }
  }
}
</style>
